import { Component, Injector, ChangeDetectorRef } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'text-area',
  templateUrl: './text-area.component.html',
})
export class TextAreaComponent extends BaseFormComponent {
  inputText: string;

  constructor(protected injector: Injector) {
    super(injector);

    this.updateFromModel(); // For the initial value
  }

  resetValue() {
    this.inputText = '';
  }

  updateFromModel() {
    const value = this.getValue(this.questionItem.prop);
    if (value !== this.inputText) {
      this.inputText = value;
    }
  }

  async trigger() {
    await this.validateAndSet(this.questionItem.prop, this.inputText);
  }

  handleBlur() {
    if (!this.errorMessage[this.questionItem.prop]) {
      this.checkEmptyAndValidate(this.questionItem.prop, this.inputText);
    }
  }

  getErrorMessage(): string {
    return this.errorMessage[this.questionItem.prop];
  }

  isError(): boolean {
    return !!this.errorMessage[this.handleIterate(this.questionItem.prop)];
  }
}
